export function clear_form_element(name) {
    const target = document.querySelectorAll(`[name="${name}"]`)[0];
    if (!target) return;
    target.value = '';
}